import styled from "styled-components";

export const ForgetPasswordFormStyled = styled.div`
  margin: auto;
  width: 100%;
  .login_header {
    margin-bottom: 10px;
    text-align: center;
    color: ${({ theme }) => theme.COLORS.PURPLE_11};
    font-size: ${({ theme }) => theme.FONT.SIZE.S18};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_SEMIBOLD};
  }
  .sub_title_form {
    margin-bottom: 40px;
    text-align: center;
    color: ${({ theme }) => theme.COLORS.PURPLE_11};
    font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
  }
  .input_wrap {
    margin-bottom: 15px;
  }
  .btn_wrap {
    margin-bottom: 40px;
  }
  .btn_forget_passwoed {
    width: 100%;
    background: transparent;
    text-align: center;
    text-decoration: underline;
    color: ${({ theme }) => theme.COLORS.PURPLE_11};
    font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
    cursor: pointer;
  }

  @media (max-width: ${({ theme }) => theme.SCREENS.MOBILE}) {
    .login_header {
      font-size: ${({ theme }) => theme.FONT.SIZE.S16};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
    }
  }
`;
